<template>
  <div class="container">
    <img src="../assets/fullLife/background.png" class="background">
    <img :src="circle1" class="circle1" />
    <div  class="circle2" />

    <div class="titleBox" v-if="currentIndex === 0" @click="navToPc">
      <img class="logo" :src="logo">
      <div class="title">德鑫互联3.0</div>
      <div class="subTitle">医疗设备全生命周期管理软件</div>
      <div class="into">进入系统</div>
    </div>

    <div class="titleBox" style="top:5%;" v-if="currentIndex === 1">
      <img class="logo" :src="logo">
      <div class="title">德鑫互联</div>
      <div class="subTitle">医疗设备全生命周期管理软件</div>
      <img class="erImg" src="../assets/fullLife/weixinER.png" ></img>
      <div style="font-size: 14px;font-weight: 400;color: #FFFFFF;margin-top: 7px;">微信扫码进入小程序</div>
    </div>

    <div class="titleBox" style="top:5%;" v-if="currentIndex === 2">
      <img class="logo" :src="logo">
      <div class="title">德鑫互联</div>
      <div class="subTitle">医疗设备全生命周期管理软件</div>
      <div class="phoneErBox">
        <img class="erImg" style="margin-top: 0px;padding: 5px;background-color: #FFFFFF;" src="../assets/fullLife/phoneER.png" ></img>
        <div class="erTips">
          <div class="android">
              <img src="../assets/fullLife/android.png" />
              <div style="margin-left: 10px;">
                <span style="font-size: 14px;font-weight: 400;color: #FFFFFF;">Android 安卓</span><br>
                <span style="font-size: 12px;font-weight: 400;color: #A8F4F2;">扫描左侧下载</span>
              </div>
          </div>

          <div class="iphone">
              <img src="../assets/fullLife/iphone.png" />
              <div style="margin-left: 14px;margin-right: 13px;">
                <span style="font-size: 14px;font-weight: 400;color: #FFFFFF;">iOS 苹果</span><br>
                <span style="font-size: 12px;font-weight: 400;color: #A8F4F2;">扫描左侧下载</span>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="chooseBox">
      <div :class="currentIndex === 0 ? 'menuBoxActive' : 'menuBox'" style="border-radius: 26px 0px 0px 26px;" @click="changeIndex(0)">
        <img v-if="currentIndex === 0" src="../assets/fullLife/pc_active.png">
        <img v-else src="../assets/fullLife/pc.png">
        <div class="name">PC端</div>
      </div>

      <div :class="currentIndex === 1 ? 'menuBoxActive' : 'menuBox'" @click="changeIndex(1)">
        <img v-if="currentIndex === 1" src="../assets/fullLife/weixin_active.png">
        <img v-else src="../assets/fullLife/weixin.png">
        <div class="name">微信小程序</div>
      </div>

      <div :class="currentIndex === 2 ? 'menuBoxActive' : 'menuBox'" style="border-radius: 0px 26px 26px 0px;" @click="changeIndex(2)">
        <img v-if="currentIndex === 2" src="../assets/fullLife/phone_active.png">
        <img v-else src="../assets/fullLife/phone.png">
        <div class="name">手机APP</div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        circle1: require('@/assets/fullLife/circle1.png'),
        circle2: require('@/assets/fullLife/circle2.png'),
        logo: require('@/assets/fullLife/logo.png'),
        currentIndex:0
      }
    },
    beforeMount(){
      //获取路径参数
      if(this.$route.query && this.$route.query.index){
        this.currentIndex = Number(this.$route.query.index)
      }
    },
    methods: {
      changeIndex(type){
        this.currentIndex = type
      },
      navToPc(){
        window.location.href = "https://www.hospital.gddx-v1.com"
      }
    }
  }
</script>

<style scoped>
  .container {
    position: fixed;
    bottom: 0;
    right: 0;

    width: 100%;
    height: 100%;
  }

  .background {
    position: fixed;
    bottom: 0;
    right: 0;

    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @keyframes circle {
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  @keyframes circleOuter {
    100% {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }

  .circle1 {
    position: absolute;
    top: 48.7%;
    left: 50.2%;
    transform: translate(-50%, -50%);
    animation: circle 5s linear infinite;
  }

  .circle2 {
        position: absolute;
        top: 48.7%;
        left: 50.2%;

        background-image: url(../assets/fullLife/circle_all.png);
        background-position: -2436px -724px;
        background-repeat: no-repeat;
        width: 648px;
        height: 674px;

        transform: translate(-50%, -50%);
        animation: circleOuter 8s linear infinite;
    }

    /* position: absolute;
    top: 48%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: circleOuter 5s linear infinite;
  } */

  .titleBox {
    position: absolute;
    top: 12%;
    left: 50%;
    transform: translate(-50%, 50%);

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .titleBox .logo {
    width: 86px;
    height: 86px;
  }

  .titleBox .title {
    font-size: 44px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 54px;
    margin-top: 20px;
    letter-spacing: 4px;
  }

  .titleBox .subTitle {
    font-size: 20px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 54px;
    letter-spacing: 2px;
    margin-top: 10px;
  }

  .titleBox .into{
    display: flex;
    justify-content: center;
    align-items: center;

    width: 240px;
    height: 45px;
    background: #181A65;
    border: 1px solid #F5F5F5;
    border-radius: 34px;

    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;

    margin-top: 40px;
  }

  .titleBox .erImg{
    width: 140px;
    height: 140px;
    margin-top: 18px;
  }

  .titleBox .into:hover{
    background: #232465;
    transform: translate(0.5px,0.5px);
  }

  .chooseBox {
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translate(-50%,-50%);

    display: flex;
  }

  .menuBox {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 160px;
    height: 52px;
    background: #130B3C;

    cursor: pointer;
  }

  .menuBoxActive{
    display: flex;
    justify-content: center;
    align-items: center;

    width: 160px;
    height: 52px;
    background: #1664FF;

    cursor: pointer;
  }

  .menuBoxActive .name{
    font-size: 16px;
    font-weight: bold;
    color: #F9F9F9;
    margin-left: 15px;
  }

  .menuBox .name{
    font-size: 16px;
    font-weight: bold;
    color: #3D385A;
    margin-left: 15px;
  }

  .phoneErBox{
    display: flex;
    align-items: center;
    justify-content: center;

    margin-top: 40px;
  }

  .erTips{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 24px;
  }

  .erTips .android{
    width: 150px;
    height: 68px;
    background: #17D3CF;
    border-radius: 8px;

    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .erTips .iphone{
    width: 150px;
    height: 68px;
    background: #1664FF;
    border-radius: 8px;
    margin-top: 10px;

    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .erTips .android::before{
    content:"";
    width:0;
    height:0;
    position:absolute;
    left:-7px;
    top:30px;
    border-top:solid 5px transparent;
    border-right:solid 7px #17D3CF;     /* 白色小三角形 */
    border-bottom:solid 5px transparent;
  }

  .erTips .iphone::before{
    content:"";
    width:0;
    height:0;
    position:absolute;
    left:-7px;
    top:30px;
    border-top:solid 5px transparent;
    border-right:solid 7px #1664FF;     /* 白色小三角形 */
    border-bottom:solid 5px transparent;
  }
</style>



// WEBPACK FOOTER //
// src/pages/fullLife.vue